
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface UserStats {
  total_trainers: number;
  total_students: number;
  active_trainers: number;
  active_students: number;
  total_subscriptions: number;
  active_subscriptions: number;
}

interface RevenueStats {
  total_revenue: number;
  monthly_revenue: number;
  avg_subscription_value: number;
}

export const useAdminStats = () => {
  return useQuery({
    queryKey: ['admin-stats'],
    queryFn: async () => {
      const [userStatsResponse, revenueStatsResponse] = await Promise.all([
        supabase.rpc('get_user_stats'),
        supabase.rpc('get_revenue_stats')
      ]);

      if (userStatsResponse.error) throw userStatsResponse.error;
      if (revenueStatsResponse.error) throw revenueStatsResponse.error;

      return {
        userStats: (userStatsResponse.data?.[0] || {}) as UserStats,
        revenueStats: (revenueStatsResponse.data?.[0] || {}) as RevenueStats
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
